import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LayoutDashboard } from './components/LayoutDashboard';
import { AdmContextProvider } from "./contexts/AdmContext";
import { Cidades } from './pages/Cidades';
import { CidadesForm } from './pages/CidadesForm';
import { Entregas } from './pages/Entregas';
import { EntregasForm } from './pages/EntregasForm';
import { Home } from './pages/Home';
import { Lista } from './pages/Lista';
import { LoginAdm } from './pages/LoginAdm';
import { Pessoas } from './pages/Pessoas';
import { PessoasForm } from './pages/PessoasForm';
import { Relatorio } from './pages/Relatorio';
import { Usuarios } from './pages/Usuarios';
import { UsuariosForm } from './pages/UsuariosForm';
import { Veiculos } from './pages/Veiculos';
import { VeiculosForm } from './pages/VeiculosForm';

function App() {
  return (
    <BrowserRouter>

      <AdmContextProvider>
        <Routes>
          <Route path="login" element={<LoginAdm />} />

          <Route path="/" element={<LayoutDashboard />}>
            <Route path="/" element={<Home />} />

            <Route path="cidades" element={<Cidades />} />
            <Route path="cidades/novo" element={<CidadesForm tipo="new" />} />
            <Route path="cidades/:id" element={<CidadesForm tipo="edit" />} />

            <Route path="pessoas" element={<Pessoas />} />
            <Route path="pessoas/novo" element={<PessoasForm tipo="new" />} />
            <Route path="pessoas/:id" element={<PessoasForm tipo="edit" />} />

            <Route path="veiculos" element={<Veiculos />} />
            <Route path="veiculos/novo" element={<VeiculosForm tipo="new" />} />
            <Route path="veiculos/:id" element={<VeiculosForm tipo="edit" />} />

            <Route path="usuarios" element={<Usuarios />} />
            <Route path="usuarios/novo" element={<UsuariosForm tipo="new" />} />
            <Route path="usuarios/:id" element={<UsuariosForm tipo="edit" />} />

            <Route path="entregas" element={<Entregas />} />
            <Route path="entregas/novo" element={<EntregasForm tipo="new" />} />
            <Route path="entregas/:id" element={<EntregasForm tipo="edit" />} />

            <Route path="lista" element={<Lista />} />

            <Route path="relatorio" element={<Relatorio />} />

          </Route>

        </Routes>
      </AdmContextProvider>

    </BrowserRouter>
  );
}

export default App;
